import { render } from "./CollapseItem.vue?vue&type=template&id=71ec1cf1"
import script from "./CollapseItem.vue?vue&type=script&lang=js"
export * from "./CollapseItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__